/* eslint-disable no-unused-vars */
import React from 'react';
import Logo from '../images/fiutur_logo.png';
import Kanit from '../fonts/Kanit-Regular.ttf';

import {
  Page,
  Text,
  View,
  Document,
  Image,
  StyleSheet,
  Font
} from '@react-pdf/renderer';
import { readableStepName, escapeEmptyDetail } from '../utils/utils';
import {StakeholdersDetails} from "../components/StakeholdersDetails/StakeholdersDetails";

const WorkflowPDF = (workflow) => {

  Font.register({
    family: 'Kanit',
    src: Kanit
  })

  // Create styles
  const styles = StyleSheet.create({
    page: {
      backgroundColor: '#03241C',
      fontFamily: 'Kanit'
    },
    logo: {
      width: '100px',
      height: 'auto',
      margin: 20,
    },
    section: {
      margin: 20,
      marginBottom: 10,
      padding: 10,
      borderRadius: 6,
      fontSize: '10px',
      fontWeight: 'normal',
      backgroundColor: '#FFFFFF',
    },
    content: {
      flexDirection: 'row',
    },
    col: {
      marginBottom: 10,
      marginRight: 20,
    },
    eventTitle: {
      fontSize: '14px',
      fontWeight: 'bold',
    },
    eventTextTitle: {
      fontSize: '12px',
      color: '#03241C',
      marginTop: 10,
    },
    eventText: {
      marginTop: 5,
      fontWeight: 'light',
    },
    eventTextAmt: {
      marginTop: 5,
    },
    pdfTitle: {
      margin: 20,
      marginBottom: 10,
      color: '#FFFFFF',
      fontSize: '14px',
      fontWeight: 'bold',
    },
  });

  const WorkflowStepsToPDF = () => (
    <Document>
      <Page size='A4' style={styles.page}>
        <Image style={styles.logo} src={Logo} alt='logo' />
        <View style={styles.pdfTitle}>
          <Text style={styles.eventText}>Reference Implementation Id</Text>
          <Text style={styles.eventText}>{workflow?.riid}</Text>
        </View>
        {
          // eslint-disable-next-line array-callback-return
          workflow?.steps.map((s, index) => {
            switch (s['@type']) {
              case 'DataCustodyReceivedStep':
                return (
                  <View style={styles.col} key={index}>
                    <View style={styles.section}>
                      <Text style={styles.eventTitle}>
                          { readableStepName(s['@type']) }
                      </Text>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextAmt}>
                            Number of active payloads: {s.payloadsAmount}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextTitle}>
                            Title:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.title)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Description:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.description)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            New Stakeholders:
                          </Text>
                          { s.newCustodians?.length > 0 ?
                              <>
                                {s.newCustodians?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                          <Text style={styles.eventTextTitle}>
                            Old Stakeholders:
                          </Text>
                          { s.oldCustodians?.length > 0 ?
                              <>
                                {s.oldCustodians?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                        </View>
                      </View>
                    </View>
                  </View>
                );
              case 'ContextualizationStep':
                return (
                  <View style={styles.col} key={index}>
                    <View style={styles.section}>
                      <Text style={styles.eventTitle}>
                          { readableStepName(s['@type']) }
                      </Text>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextAmt}>
                            Number of active payloads: {s.payloadsAmount}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextTitle}>
                            Title:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.title)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Description:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.description)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Stakeholders:
                          </Text>
                          { s.stakeholders?.length > 0 ?
                              <>
                                {s.stakeholders?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                          <Text style={styles.eventTextTitle}>
                            Process Name:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.processName)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Process Version:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.processVersion)}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                );
              case 'ContextualizationRequestStep':
                return (
                  <View style={styles.col} key={index}>
                    <View style={styles.section}>
                      <Text style={styles.eventTitle}>
                          { readableStepName(s['@type']) }
                      </Text>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextAmt}>
                            Number of active payloads: {s.payloadsAmount}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextTitle}>
                            Title:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.title)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Description:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.description)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Requesting Stakeholders:
                          </Text>
                          { s.requestingStakeholders?.length > 0 ?
                              <>
                                {s.requestingStakeholders?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                          <Text style={styles.eventTextTitle}>
                            Receiving Stakeholders:
                          </Text>
                          { s.receivingStakeholders?.length > 0 ?
                              <>
                                {s.receivingStakeholders?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                          <Text style={styles.eventTextTitle}>
                            Process Name:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.processName)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Process Version:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.processVersion)}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                );
              case 'IDGeneratorStep':
                return (
                  <View style={styles.col} key={index}>
                    <View style={styles.section}>
                      <Text style={styles.eventTitle}>
                          { readableStepName(s['@type']) }
                      </Text>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextAmt}>
                            Number of active payloads: {s.payloadsAmount}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextTitle}>
                            Title:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.title)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Description:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.description)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            New Stakeholders:
                          </Text>
                          { s.stakeholders?.length > 0 ?
                              <>
                                {s.stakeholders?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                          <Text style={styles.eventTextTitle}>
                            Process Name:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.processName)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Process Version:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.processVersion)}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                );
              case 'DataCustodyRequestedStep':
                return (
                  <View style={styles.col} key={index}>
                    <View style={styles.section}>
                      <Text style={styles.eventTitle}>
                          { readableStepName(s['@type']) }
                      </Text>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextAmt}>
                            Number of active payloads: {s.payloadsAmount}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextTitle}>
                            Title:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.title)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Description:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.description)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            New Stakeholders:
                          </Text>
                          { s.newCustodians?.length > 0 ?
                              <>
                                {s.newCustodians?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                          <Text style={styles.eventTextTitle}>
                            Old Stakeholders:
                          </Text>
                          { s.oldCustodians?.length > 0 ?
                              <>
                                {s.oldCustodians?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                        </View>
                      </View>
                    </View>
                  </View>
                );
              case 'RegistrationStep':
                return (
                  <View style={styles.col} key={index}>
                    <View style={styles.section}>
                      <Text style={styles.eventTitle}>
                          { readableStepName(s['@type']) }
                      </Text>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextAmt}>
                            Number of active payloads: {s.payloadsAmount}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextTitle}>
                            Title:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.title)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Description:
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Registry Stakeholders:
                          </Text>
                          { s.registryStakeholders?.length > 0 ?
                              <>
                                {s.registryStakeholders?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                          <Text style={styles.eventTextTitle}>
                            Old Stakeholders:
                          </Text>
                          { s.oldCustodians?.length > 0 ?
                              <>
                                {s.oldCustodians?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                        </View>
                      </View>
                    </View>
                  </View>
                );
              case 'AssetRegistrationStep':
                return (
                  <View style={styles.col} key={index}>
                    <View style={styles.section}>
                      <Text style={styles.eventTitle}>
                          { readableStepName(s['@type']) }
                      </Text>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextAmt}>
                            Number of active payloads: {s.payloadsAmount}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.content}>
                        <View style={styles.col}>
                          <Text style={styles.eventTextTitle}>
                            Title:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.title)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Description:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.description)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Old Stakeholders:
                          </Text>
                          { s.oldCustodians?.length > 0 ?
                              <>
                                {s.oldCustodians?.map((el, index) => {
                                  return (
                                      <Text key={index} style={styles.eventTextTab}>
                                        Organization Id: {escapeEmptyDetail(el.organizationId)}{'\n'}
                                        Organization Name: {escapeEmptyDetail(el.organizationName)}{'\n'}
                                        Role Type: {escapeEmptyDetail(el.roleType)}{'\n'}
                                      </Text>
                                  )
                                })}
                              </>
                              :
                              <Text style={styles.eventText}>
                                -
                              </Text>
                          }
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.oldCustodianPartyName)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Registry Account Id:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.registryAccountId)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Registry Account Name:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.registryAccountName)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Registry:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.registry)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Registry Provider:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.registryProvider)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Registry Environment:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.registryEnvironment)}
                          </Text>
                          <Text style={styles.eventTextTitle}>
                            Registry API Version:
                          </Text>
                          <Text style={styles.eventText}>
                            {escapeEmptyDetail(s.registryAPIVersion)}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                );
              default:
                console.log(
                  'Step not set on the FE -> check file WorkflowSteps.jsx'
                );
            }
          })
        }
      </Page>
    </Document>
  );

  return <>{WorkflowStepsToPDF()}</>;
};

export default WorkflowPDF;